

/**Way for reports to get the denomintor to full */
export function denominatorToFull(value: number) {
    return (value / 100).toFixed(2);
}